import script from "./PrimaryNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./PrimaryNavbar.vue?vue&type=script&setup=true&lang=js"

import "./PrimaryNavbar.vue?vue&type=style&index=0&id=28f86f22&scoped=true&lang=css"

import exportComponent from "c:\\DevOpsProdCore2_02\\_work\\161\\s\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28f86f22"]])

export default __exports__